<template>
  <!-- HOTELERÍA -->
  <div class="hoteleria-solicitudes">
    <div class="hoteleria-solicitudes__fondo">
      <div class="container-fluid hoteleria-solicitudes__container">
        <div class="row hoteleria-solicitudes__row justify-content-center">
          <div
            class="
              col-lg-11 col-md-11 col-sm-11 col-11
              hoteleria-solicitudes__col hoteleria-solicitudes__col--titulo
              text-start
              pt-3
              mb-0
            "
          >
            <h1
              class="hoteleria-solicitudes__h1 mb-0"
              :style="{ color: colorPrimario }"
            >
              Solicitudes
            </h1>
            <router-link
              to="/home"
              class="hoteleria-solicitudes__link-home"
              aria-label="Acceder a este hoteleria-solicitudes"
            >
              <IconHome  />
            </router-link>
            <router-link
              to="/hoteleria"
              class="teamworkup-tv-single__link-home"
              :style="{ color: colorPrimario }"
            >
              > Hotelería >
            </router-link>
            <span
              class="teamworkup-tv-single__link-home"
              :style="{ color: colorPrimario }"
              >Solicitudes</span
            >
            <div class="row hoteleria-solicitudes__row justify-content-center">
              <div
                class="
                  col-xxl-10 col-xl-9 col-lg-8 col-md-7 col-12
                  hoteleria-solicitudes__col
                "
              >
                <p class="hoteleria-solicitudes__subtitulo mt-2">
                  ¡Disfruta los beneficios que tenemos para ti y tu familia!
                  Conócelos y solicítalos aquí.
                </p>
              </div>
              <div
                class="
                  col-xxl-2 col-xl-3 col-lg-4 col-md-5 col-sm-6 col-11
                  ps-1
                  hoteleria-solicitudes__col
                "
              >
                <nav class="hoteleria-filtro">
                  <div
                    class="nav nav-tabs hoteleria-filtro__tabs"
                    id="nav-tab"
                    role="tablist"
                  >
                    <button
                      class="nav-link active hoteleria-filtro__nav-tabs"
                      id="nav-home-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-home"
                      type="button"
                      role="tab"
                      aria-controls="nav-home"
                      aria-selected="true"
                      @click="aSolicitar"
                      :style="{
                        backgroundColor: butonActive ? colorPrimario : '#fff',
                        borderRadius: '20px',
                        color: butonActive ? '#fff !important' : '#6B6E7F',
                      }"
                    >
                      Solicitar
                    </button>
                    <button
                      class="nav-link hoteleria-filtro__nav-tabs"
                      id="nav-profile-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-profile"
                      type="button"
                      role="tab"
                      aria-controls="nav-profile"
                      aria-selected="false"
                      @click="aHistorial"
                      :style="{
                        backgroundColor: !butonActive ? colorPrimario : '#fff',
                        borderRadius: '20px',
                        color: !butonActive ? '#fff !important' : '#6B6E7F',
                      }"
                    >
                      Historial
                    </button>
                  </div>
                </nav>
              </div>
            </div>
          </div>
          <div class="col-11 hoteleria-solicitudes__col">
            <hr class="hoteleria-solicitudes__hr" />
          </div>
        </div>
        <div class="row hoteleria-solicitudes__row justify-content-center">
          <div
            class="
              col-lg-11 col-md-11 col-sm-11 col-11
              hoteleria-solicitudes__col hoteleria-solicitudes__div-solicitar
            "
          >
            <div class="row hoteleria-solicitudes__row justify-content-center">
              <div
                class="
                  col-lg-12 col-md-12 col-sm-12 col-12
                  hoteleria-solicitudes__col
                  hoteleria-solicitudes__col--bg-blanco
                  px-3
                  pb-3
                  pt-4
                  mb-2
                "
              >
                <div class="row hoteleria-solicitudes__row">
                  <div
                    class="
                      col-lg-6 col-md-6 col-12
                      hoteleria-solicitudes__col
                      text-start
                      mb-3
                      px-0
                    "
                  >
                    <h2
                      class="hoteleria-solicitudes__titulo-formulario mb-3"
                      :style="{
                        color: formTwoActive == false ? colorPrimario : '',
                      }"
                    >
                      Ingreso de solicitud
                    </h2>
                    <div
                      class="
                        hoteleria-solicitudes__formulario-a
                        mx-auto
                        pt-3
                        pb-4
                        overflow-hidden
                      "
                      :style="{
                        'border-color':
                          formTwoActive == false ? colorPrimario : '',
                      }"
                    >
                      <div
                        class="
                          row
                          hoteleria-solicitudes__row
                          justify-content-center
                          px-3
                        "
                      >
                        <div
                          class="col-12 hoteleria-solicitudes__col text-start"
                        >
                          <h3 class="hoteleria-solicitudes__h3-formulario">
                            Valida tu información de contacto
                          </h3>
                          <hr class="hoteleria-solicitudes__hr mb-1" />
                        </div>
                        <div
                          class="
                            col-lg-6 col-md-12 col-12
                            px-2
                            hoteleria-solicitudes__col
                            text-start
                            mb-3
                          "
                        >
                          <label
                            for="select-2"
                            class="form-label hoteleria-solicitudes__label"
                            >Teléfono</label
                          >
                          <input
                            type="text"
                            class="form-control hoteleria-solicitudes__input"
                            placeholder="988765432"
                            v-model="usuario.telefono_movil"
                            :disabled="formTwoActive"
                          />
                        </div>
                        <div
                          class="
                            col-lg-6 col-md-12 col-12
                            px-2
                            hoteleria-solicitudes__col
                            text-start
                            mb-3
                          "
                        >
                          <label
                            for="select-2"
                            class="form-label hoteleria-solicitudes__label"
                            >Mail</label
                          >
                          <input
                            type="email"
                            class="form-control hoteleria-solicitudes__input"
                            placeholder="cliente@cliente.cl"
                            v-model="usuario.correo"
                            :disabled="formTwoActive"
                          />
                        </div>
                      </div>
                      <div
                        class="
                          row
                          hoteleria-solicitudes__row
                          justify-content-center
                          px-3
                          mt-2
                        "
                      >
                        <div
                          class="col-12 hoteleria-solicitudes__col text-start"
                        >
                          <h3 class="hoteleria-solicitudes__h3-formulario">
                            Información turno
                          </h3>
                          <hr class="hoteleria-solicitudes__hr mb-1" />
                        </div>
                        <div
                          class="
                            col-lg-6 col-md-12 col-12
                            px-2
                            hoteleria-solicitudes__col
                            text-start
                            mb-3
                          "
                        >
                          <label
                            for="select-2"
                            class="form-label hoteleria-solicitudes__label"
                            >Turno</label
                          >
                          <div class="dropdown dropdown-selector">
                            <button
                              class="dropdown-toggle dropdown-selector__toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              :disabled="formTwoActive"
                            >
                              {{ capitalizeFirstLetter(selected.turno) }}
                              <font-awesome-icon icon="fa-solid fa-caret-up" class=" ms-2 dropdown-selector__icono-flecha"></font-awesome-icon>
                             <font-awesome-icon icon="fa-solid fa-caret-down" class="ms-2 dropdown-selector__icono-flecha-b"></font-awesome-icon>
                            </button>
                            <ul
                              class="dropdown-menu dropdown-selector__menu"
                              v-if="turnos"
                            >
                              <li
                                v-for="turno in turnos"
                                :key="turno.id_turno"
                                @click="
                                  changeSelected(turno.id_turno, 'id_turno');
                                  changeSelectedText(
                                    turno.nombre_turno,
                                    'turno'
                                  );
                                "
                              >
                                <a
                                  class="dropdown-item dropdown-selector__item"
                                  >{{
                                    capitalizeFirstLetter(turno.nombre_turno)
                                  }}</a
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div
                          class="
                            col-lg-6 col-md-12 col-12
                            px-2
                            hoteleria-solicitudes__col
                            text-start
                            mb-3
                          "
                        >
                          <label
                            for="select-2"
                            class="form-label hoteleria-solicitudes__label"
                            >Team</label
                          >
                          <div class="dropdown dropdown-selector">
                            <button
                              class="dropdown-toggle dropdown-selector__toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              :disabled="formTwoActive"
                            >
                              {{ capitalizeFirstLetter(selected.team) }}
                              <font-awesome-icon icon="fa-solid fa-caret-up" class=" ms-2 dropdown-selector__icono-flecha"></font-awesome-icon>
                             <font-awesome-icon icon="fa-solid fa-caret-down" class="ms-2 dropdown-selector__icono-flecha-b"></font-awesome-icon>
                            </button>
                            <ul
                              class="dropdown-menu dropdown-selector__menu"
                              v-if="teams"
                            >
                              <li
                                v-for="team in teams"
                                :key="team.id_team"
                                @click="
                                  changeSelected(team.id_team, 'id_team');
                                  changeSelectedText(team.nombre_team, 'team');
                                "
                              >
                                <a
                                  class="dropdown-item dropdown-selector__item"
                                  >{{
                                    capitalizeFirstLetter(team.nombre_team)
                                  }}</a
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div
                        class="
                          row
                          hoteleria-solicitudes__row
                          justify-content-center
                          px-3
                          mt-2
                        "
                      >
                        <div
                          class="col-12 hoteleria-solicitudes__col text-start"
                        >
                          <h3 class="hoteleria-solicitudes__h3-formulario">
                            Información habitación
                          </h3>
                          <hr class="hoteleria-solicitudes__hr mb-1" />
                        </div>
                        <div
                          class="
                            col-lg-6 col-md-12 col-12
                            px-2
                            hoteleria-solicitudes__col
                            text-start
                            mb-3
                          "
                        >
                          <label
                            for="select-2"
                            class="form-label hoteleria-solicitudes__label"
                            >Pabellón</label
                          >
                          <div class="dropdown dropdown-selector">
                            <button
                              class="dropdown-toggle dropdown-selector__toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              :disabled="formTwoActive"
                            >
                              {{ selected.pabellon }}
                              <font-awesome-icon icon="fa-solid fa-caret-up" class=" ms-2 dropdown-selector__icono-flecha"></font-awesome-icon>
                             <font-awesome-icon icon="fa-solid fa-caret-down" class="ms-2 dropdown-selector__icono-flecha-b"></font-awesome-icon>
                            </button>
                            <ul
                              class="dropdown-menu dropdown-selector__menu"
                              v-if="getAllPabellones"
                            >
                              <li
                                v-for="pabellon in getAllPabellones"
                                :key="pabellon.id_pabellon"
                                @click="
                                  changeSelected(
                                    pabellon.id_pabellon,
                                    'id_pabellon'
                                  );
                                  changeSelectedText(
                                    pabellon.nombre_pabellon,
                                    'pabellon'
                                  );
                                "
                              >
                                <a
                                  class="dropdown-item dropdown-selector__item"
                                  >{{ pabellon.nombre_pabellon }}</a
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div
                          class="
                            col-lg-6 col-md-12 col-12
                            px-2
                            hoteleria-solicitudes__col
                            text-start
                            mb-3
                          "
                        >
                          <label
                            for="select-2"
                            class="form-label hoteleria-solicitudes__label"
                            >Habitación</label
                          >
                          <div class="dropdown dropdown-selector">
                            <button
                              class="dropdown-toggle dropdown-selector__toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              :disabled="formTwoActive"
                            >
                              {{ selected.habitacion }}
                              <font-awesome-icon icon="fa-solid fa-caret-up" class=" ms-2 dropdown-selector__icono-flecha"></font-awesome-icon>
                             <font-awesome-icon icon="fa-solid fa-caret-down" class="ms-2 dropdown-selector__icono-flecha-b"></font-awesome-icon>
                            </button>
                            <ul
                              class="dropdown-menu dropdown-selector__menu"
                              v-if="getAllHabitaciones"
                            >
                              <li
                                v-for="habitacion in getAllHabitaciones"
                                :key="habitacion.id_habitacion"
                                @click="
                                  changeSelected(
                                    habitacion.id_habitacion,
                                    'id_habitacion'
                                  );
                                  changeSelectedText(
                                    habitacion.nombre_habitacion,
                                    'habitacion'
                                  );
                                "
                              >
                                <a
                                  class="dropdown-item dropdown-selector__item"
                                  >{{ habitacion.nombre_habitacion }}</a
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div
                          class="
                            col-lg-6 col-md-12 col-12
                            px-2
                            hoteleria-solicitudes__col
                            text-start
                            mb-3
                          "
                        >
                          <label
                            for="select-2"
                            class="form-label hoteleria-solicitudes__label"
                            >Ubicación cama</label
                          >
                          <div class="dropdown dropdown-selector">
                            <button
                              class="dropdown-toggle dropdown-selector__toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              :disabled="formTwoActive"
                            >
                              {{ selected.cama }}
                              <font-awesome-icon icon="fa-solid fa-caret-up" class=" ms-2 dropdown-selector__icono-flecha"></font-awesome-icon>
                             <font-awesome-icon icon="fa-solid fa-caret-down" class="ms-2 dropdown-selector__icono-flecha-b"></font-awesome-icon>
                            </button>
                            <ul
                              class="dropdown-menu dropdown-selector__menu"
                              v-if="getAllUbicacionCama"
                            >
                              <li
                                v-for="cama in getAllUbicacionCama"
                                :key="cama.id_cama"
                                @click="
                                  changeSelected(cama.id_cama, 'id_cama');
                                  changeSelectedText(
                                    cama.nombre_ubicacion,
                                    'cama'
                                  );
                                "
                              >
                                <a
                                  class="dropdown-item dropdown-selector__item"
                                  >{{ cama.nombre_ubicacion }}</a
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div
                          class="
                            col-lg-6 col-md-12 col-12
                            px-2
                            hoteleria-solicitudes__col
                            text-start
                            mb-3
                          "
                        >
                          <label
                            for="select-2"
                            class="form-label hoteleria-solicitudes__label"
                            >Ubicación clóset</label
                          >
                          <div class="dropdown dropdown-selector">
                            <button
                              class="dropdown-toggle dropdown-selector__toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              :disabled="formTwoActive"
                            >
                              {{ selected.closet }}
                              <font-awesome-icon icon="fa-solid fa-caret-up" class=" ms-2 dropdown-selector__icono-flecha"></font-awesome-icon>
                             <font-awesome-icon icon="fa-solid fa-caret-down" class="ms-2 dropdown-selector__icono-flecha-b"></font-awesome-icon>
                            </button>
                            <ul
                              class="dropdown-menu dropdown-selector__menu"
                              v-if="getAllUbicacionCloset"
                            >
                              <li
                                v-for="closet in getAllUbicacionCloset"
                                :key="closet.id_closet"
                                @click="
                                  changeSelected(closet.id_closet, 'id_closet');
                                  changeSelectedText(
                                    closet.nombre_ubicacion,
                                    'closet'
                                  );
                                "
                              >
                                <a
                                  class="dropdown-item dropdown-selector__item"
                                  >{{ closet.nombre_ubicacion }}</a
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div
                        class="
                          row
                          hoteleria-solicitudes__row
                          hoteleria-solicitudes__row--boton
                          justify-content-center
                          mt-3
                        "
                      >
                        <div
                          class="
                            col-11
                            hoteleria-solicitudes__col
                            hoteleria-solicitudes__col--btn-sig-a
                            px-0
                            text-end
                          "
                        >
                          <!-- Botón aparece sólo si se completa el formulario -->
                          <button
                            class="
                              hoteleria-solicitudes__boton
                              boton-pill boton-pill--fondo-lila
                              px-4
                              py-1
                            "
                            data-bs-toggle="collapse"
                            data-bs-target="#formulario-2"
                            aria-expanded="false"
                            aria-controls="collapseWidthExample"
                            v-if="!formTwoActive"
                            :disabled="validateForm1()"
                            @click="activateFormTwo"
                            :style="{ backgroundColor: colorPrimario }"
                          >
                            Siguiente
                          </button>
                          <!-- Botón aparece sólo si se completa el formulario -->
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="
                      col-lg-6 col-md-6 col-12
                      hoteleria-solicitudes__col
                      text-start
                      mb-3
                      px-0
                      collapse collapse-horizontal
                    "
                    id="formulario-2"
                    ref="scrollForm2"
                  >
                    <h2
                      class="hoteleria-solicitudes__titulo-formulario mb-3"
                      :style="{
                        color: formTwoActive == true ? colorPrimario : '',
                      }"
                    >
                      Selecciona tipo de problema
                    </h2>
                    <div
                      class="hoteleria-solicitudes__formulario-b mx-auto pt-3"
                      :style="{
                        'border-color':
                          formTwoActive == true ? colorPrimario : '',
                      }"
                    >
                      <div
                        class="
                          row
                          hoteleria-solicitudes__row
                          justify-content-center
                          px-3
                        "
                      >
                        <div
                          class="col-12 hoteleria-solicitudes__col text-start"
                        >
                          <h3 class="hoteleria-solicitudes__h3-formulario">
                            Selecciona el tipo de servicio
                          </h3>
                          <hr class="hoteleria-solicitudes__hr mb-1" />
                        </div>
                        <div
                          class="
                            col-lg-12 col-md-12 col-12
                            px-2
                            hoteleria-solicitudes__col
                            text-start
                            mb-3
                          "
                        >
                          <label
                            for="select-2"
                            class="form-label hoteleria-solicitudes__label"
                            >Categoría</label
                          >
                          <div class="dropdown dropdown-selector">
                            <button
                              class="dropdown-toggle dropdown-selector__toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              {{ selected.servicio }}
                              <font-awesome-icon icon="fa-solid fa-caret-up" class=" ms-2 dropdown-selector__icono-flecha"></font-awesome-icon>
                             <font-awesome-icon icon="fa-solid fa-caret-down" class="ms-2 dropdown-selector__icono-flecha-b"></font-awesome-icon>
                            </button>
                            <ul
                              class="dropdown-menu dropdown-selector__menu"
                              v-if="getAllServiciosADetalles"
                            >
                              <li
                                v-for="servicio in getAllServiciosADetalles"
                                :key="servicio.id_servicio"
                                @click="
                                  changeSelected(
                                    servicio.id_servicio,
                                    'id_servicio'
                                  );
                                  changeSelectedText(
                                    servicio.nombre_servicio +
                                      ' - ' +
                                      servicio.descripcion_servicio,
                                    'servicio'
                                  );
                                "
                              >
                                <a
                                  class="dropdown-item dropdown-selector__item"
                                >
                                  {{ servicio.nombre_servicio }} -
                                  {{ servicio.descripcion_servicio }}</a
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div
                        class="
                          row
                          hoteleria-solicitudes__row
                          justify-content-center
                          px-3
                        "
                      >
                        <div class="col-lg-6 col-12 hoteleria-solicitudes__col">
                          <div
                            class="row hoteleria-solicitudes__row"
                            v-if="
                              servicios.find(
                                (servicio) =>
                                  servicio.id_servicio == form.id_servicio
                              )
                            "
                          >
                            <div
                              class="
                                col-12
                                hoteleria-solicitudes__col
                                text-start
                                mb-3
                              "
                            >
                              <label
                                for="select-1"
                                class="form-label hoteleria-solicitudes__label"
                                >Selecciona problema</label
                              >
                              <div
                                class="
                                  hoteleria-solicitudes__div-borde-gris
                                  py-2
                                  ps-2
                                "
                              >
                                <div
                                  class="
                                    form-check
                                    hoteleria-solicitudes__form-check
                                    mb-1
                                  "
                                  v-for="detalle in servicios.find(
                                    (servicio) =>
                                      servicio.id_servicio == form.id_servicio
                                  ).detalle"
                                  :key="detalle.id_detalle"
                                >
                                  <input
                                    class="
                                      form-check-input
                                      hoteleria-solicitudes__check-input
                                    "
                                    type="checkbox"
                                    :id="`check-detalle-${detalle.id_detalle}`"
                                    :value="detalle.id_detalle"
                                    @change="
                                      onDetalleChecked(
                                        $event,
                                        detalle.id_detalle,
                                        detalle.nombre_detalle
                                      )
                                    "
                                  />
                                  <label
                                    class="
                                      form-check-label
                                      hoteleria-solicitudes__label-check
                                    "
                                    :for="`check-detalle-${detalle.id_detalle}`"
                                  >
                                    {{ detalle.nombre_detalle }}
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div
                              class="
                                col-12
                                hoteleria-solicitudes__col
                                text-start
                                mb-3
                                position-relative
                              "
                            >
                              <label
                                for="textarea-reconoce"
                                class="form-label hoteleria-solicitudes__label"
                                >Ingresa detalle de tu solicitud
                                (opcional)</label
                              >
                              <textarea
                                class="
                                  form-control
                                  hoteleria-solicitudes__textarea
                                "
                                v-model="form.descripcion_solicitud"
                                rows="5"
                                maxlength="250"
                                placeholder="Escribe aquí"
                              ></textarea>
                              <div class="text-end hoteleria-solicitudes__div">
                                <span
                                  class="
                                    hoteleria-solicitudes__contador-caracteres
                                  "
                                  >{{ form.descripcion_solicitud.length }}/
                                  <span>250</span></span
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="
                            col-lg-6 col-11
                            hoteleria-solicitudes__col
                            text-start
                          "
                          v-if="
                            servicios.find(
                              (servicio) =>
                                servicio.id_servicio == form.id_servicio
                            )
                          "
                        >
                          <label
                            for="input-imagen"
                            class="form-label hoteleria-solicitudes__label"
                            >Agrega una imagen</label
                          >
                          <div class="row hoteleria-solicitudes__row">
                            <div
                              class="
                                col-12
                                position-relative
                                hoteleria-solicitudes__col
                                hoteleria-solicitudes__col--bg-gris
                                text-center
                              "
                            >
                              <div
                                class="hoteleria-solicitudes__div-input-archivo"
                                :style="{
                                  borderColor: colorPrimario,
                                }"
                              >
                                <!-- Vista previa de la imagen, sólo aparece cuando se sube el archivo -->
                                <img
                                  v-if="form.documentos.imagen !== ''"
                                  :src="form.documentos.imagen"
                                  class="
                                    hoteleria-solicitudes__vista-previa-img
                                  "
                                  alt="Vista previa de la imagen"
                                />

                                <span
                                  v-else
                                  class="
                                    hoteleria-solicitudes__texto-input-archivo
                                  "
                                  :style="{
                                    color: colorPrimario,
                                  }"
                                >
                                  <img
                                    src="@/assets/img/intranet/reconocer-colaborador/icono-subir-archivo.png"
                                    class="hoteleria-solicitudes__icono-subir"
                                    alt="Ícono de reconocimiento"
                                  />
                                  <br />
                                  Haz click aquí
                                </span>

                                <!-- Quitar la imagen, sólo aparece cuando se sube el archivo -->
                                <button
                                  v-if="form.documentos.imagen !== ''"
                                  class="hoteleria-solicitudes__btn-quitar"
                                  @click="quitarImg"
                                >
                                  x
                                </button>
                              </div>

                              <input
                                class="
                                  form-control
                                  hoteleria-solicitudes__input-archivo
                                "
                                type="file"
                                accept="image/*"
                                @change="handleFile"
                                ref="file"
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          class="
                            col-11
                            hoteleria-solicitudes__col
                            hoteleria-solicitudes__col--btn-sig
                            px-0
                            text-end
                          "
                        >
                          <!-- Botón aparece sólo si se completa el formulario -->
                          <button
                            class="
                              hoteleria-solicitudes__boton
                              boton-pill boton-pill--fondo-lila
                              px-4
                              py-1
                            "
                            data-bs-toggle="modal"
                            data-bs-target="#modal-confirmar"
                            :disabled="validateForm2()"
                            :style="{ backgroundColor: colorPrimario }"
                          >
                            Siguiente
                          </button>
                          <!-- Botón aparece sólo si se completa el formulario -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <HistorialSolicitudes  />
        </div>
      </div>
    </div>

    <!-- MODAL CONFIRMAR SOLICITUD -->
    <div
      class="modal fade modal-confirmar"
      id="modal-confirmar"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div
        class="
          modal-dialog modal-dialog-centered modal-lg
          modal-confirmar__dialog
        "
      >
        <div class="modal-content modal-confirmar__content">
          <div class="modal-header modal-confirmar__header">
            <button
              type="button"
              class="btn-close modal-confirmar__btn-cerrar"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body modal-confirmar__body">
            <div class="container modal-confirmar__container">
              <div class="row modal-confirmar__row">
                <div class="col-12 modal-confirmar__col text-start">
                  <h3 class="modal-confirmar__h3">Confirma tu solicitud</h3>
                </div>
                <div class="col-lg-6 col-md-6 col-12 modal-confirmar__col">
                  <div class="row modal-confirmar__row">
                    <div class="modal-confirmar__col text-start">
                      <p class="modal-confirmar__titulo mb-0">
                        Resumen solicitud
                      </p>
                      <hr class="modal-confirmar__hr" />
                    </div>
                  </div>
                  <div class="row modal-confirmar__row justify-content-start">
                    <p class="modal-confirmar__subtitulo mb-1 text-start">
                      Categoría
                    </p>
                    <div class="modal-confirmar__col-bordes text-start py-1">
                      <p
                        class="
                          modal-confirmar__texto modal-confirmar__texto--18px
                          mb-0
                        "
                      >
                        {{ selectedServicio }}
                      </p>
                    </div>
                  </div>
                  <div class="row modal-confirmar__row mt-3">
                    <div class="modal-confirmar__col text-start">
                      <p class="modal-confirmar__titulo mb-0">
                        Problema reportado
                      </p>
                      <hr class="modal-confirmar__hr mb-1" />
                    </div>
                  </div>
                  <div
                    class="row modal-confirmar__row justify-content-start"
                    v-if="form.detalles.length > 0"
                  >
                    <div
                      class="modal-confirmar__col text-start py-1"
                      v-for="detalle in form.detalles"
                      :key="detalle.id_detalle"
                    >
                      <p class="modal-confirmar__texto mb-0">
                        <img
                          src="@/assets/img/intranet/hoteleria-solicitudes/icono-check-gris.png"
                          class="modal-confirmar__icono-check"
                          alt="Check de problema"
                        />
                        {{ detalle.descripcion_detalle }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-12 modal-confirmar__col">
                  <img
                    :src="form.documentos.imagen"
                    class="modal-confirmar__img-confirmacion mx-auto"
                    alt="Ícono de valor"
                  />
                </div>
                <div class="col-12 col-md-12 col-12 modal-confirmar__col mt-3">
                  <div class="row modal-confirmar__row">
                    <div class="modal-confirmar__col text-start">
                      <p class="modal-confirmar__titulo mb-0">
                        Detalle solicitud
                      </p>
                    </div>
                  </div>
                  <div class="row modal-confirmar__row justify-content-start">
                    <div
                      class="modal-confirmar__col-bordes text-start pt-1 pb-3"
                    >
                      <p
                        class="
                          modal-confirmar__texto modal-confirmar__texto--18px
                          mb-0
                        "
                      >
                        {{ form.descripcion_solicitud }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer modal-confirmar__footer">
            <div class="container modal-confirmar__container">
              <div class="row modal-confirmar__row mt-2 justify-content-end">
                <div class="col-lg-12">
                  <hr class="modal-confirmar__hr" />
                </div>
                <div
                  class="
                    col-lg-12 col-md-12 col-12
                    mb-2
                    modal-confirmar__col--botones
                    text-end
                  "
                >
                  <button
                    class="modal-confirmar__btn-gris me-3"
                    data-bs-dismiss="modal"
                  >
                    Atrás
                  </button>
                  <button
                    class="modal-confirmar__btn-lila"
                    @click="handleSubmit"
                  >
                    Enviar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- MODAL CONFIRMAR SOLICITUD -->

    <!-- MODAL VER SOLICITUD -->
    <div
      class="modal fade modal-confirmar"
      id="ver-detalle-solicitud"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div
        class="
          modal-dialog modal-dialog-centered modal-lg
          modal-confirmar__dialog
        "
      >
        <div class="modal-content modal-confirmar__content">
          <div class="modal-header modal-confirmar__header">
            <button
              type="button"
              class="btn-close modal-confirmar__btn-cerrar"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body modal-confirmar__body">
            <div class="container modal-confirmar__container">
              <div class="row modal-confirmar__row">
                <div class="col-12 modal-confirmar__col text-start">
                  <h3 class="modal-confirmar__h3">Detalles de la solicitud</h3>
                </div>
                <div class="col-lg-6 col-md-6 col-12 modal-confirmar__col">
                  <div class="row modal-confirmar__row">
                    <div class="modal-confirmar__col text-start">
                      <p class="modal-confirmar__titulo mb-0">
                        Resumen solicitud
                      </p>
                      <hr class="modal-confirmar__hr" />
                    </div>
                  </div>
                  <div class="row modal-confirmar__row justify-content-start">
                    <p class="modal-confirmar__subtitulo mb-1 text-start">
                      Categoría
                    </p>
                    <div class="modal-confirmar__col-bordes text-start py-1">
                      <p
                        class="
                          modal-confirmar__texto modal-confirmar__texto--18px
                          mb-0
                        "
                      >
                        {{ selectedServicio }}
                      </p>
                    </div>
                  </div>
                  <div class="row modal-confirmar__row mt-3">
                    <div class="modal-confirmar__col text-start">
                      <p class="modal-confirmar__titulo mb-0">
                        Problema reportado
                      </p>
                      <hr class="modal-confirmar__hr mb-1" />
                    </div>
                  </div>
                  <div
                    class="row modal-confirmar__row justify-content-start"
                    v-if="form.detalles.length > 0"
                  >
                    <div
                      class="modal-confirmar__col text-start py-1"
                      v-for="detalle in form.detalles"
                      :key="detalle.id_detalle"
                    >
                      <p class="modal-confirmar__texto mb-0">
                        <img
                          src="@/assets/img/intranet/hoteleria-solicitudes/icono-check-gris.png"
                          class="modal-confirmar__icono-check"
                          alt="Check de problema"
                        />
                        {{ detalle.nombre_detalle }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-12 modal-confirmar__col">
                  <img
                    :src="form.documentos.imagen"
                    class="modal-confirmar__img-confirmacion mx-auto"
                    alt="Ícono de valor"
                  />
                </div>
                <div class="col-12 col-md-12 col-12 modal-confirmar__col mt-3">
                  <div class="row modal-confirmar__row">
                    <div class="modal-confirmar__col text-start">
                      <p class="modal-confirmar__titulo mb-0">
                        Detalle solicitud
                      </p>
                    </div>
                  </div>
                  <div class="row modal-confirmar__row justify-content-start">
                    <div
                      class="modal-confirmar__col-bordes text-start pt-1 pb-3"
                    >
                      <p
                        class="
                          modal-confirmar__texto modal-confirmar__texto--18px
                          mb-0
                        "
                      >
                        {{ form.descripcion_solicitud }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer modal-confirmar__footer"></div>
        </div>
      </div>
    </div>
    <!-- MODAL VER SOLICITUD -->

    <ModalVerSolicitudHistorial  />

    <!-- MODAL ÉXITO -->
    <div
      class="modal modal-exito fade"
      id="modal-exito"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-exito__dialog modal-dialog-centered">
        <div class="modal-content modal-exito__content-exito">
          <div class="modal-header modal-exito__header pb-0">
            <img
              src="@/assets/img/intranet/hoteleria-solicitudes/cara-feliz.svg"
              class="modal-exito__icono-exito"
              alt="Ícono de valor"
            />
          </div>
          <div class="modal-body modal-exito__body py-0">
            <div class="container modal-exito__container">
              <div class="row modal-exito__row justify-content-center">
                <div
                  class="
                    col-lg-7 col-md-9 col-10
                    modal-exito__col
                    text-center
                    my-3
                  "
                >
                  <p class="modal-exito__parrafo">
                    Tu Solicitud ha sido enviada correctamente
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            class="
              modal-footer
              modal-exito__footer
              pb-4
              position-relative
              text-center
            "
          >
            <button
              class="modal-exito__btn-finalizar px-4 py-1"
              data-bs-dismiss="modal"
              @click="redirect()"
            >
              Finalizar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- MODAL ÉXITO -->

    <button
      class="d-none"
      data-bs-toggle="modal"
      data-bs-target="#modal-exito"
      id="btn-modal-exito"
    ></button>
  </div>
  <!-- fin HOTELERÍA -->
</template>

<script>
// @ is an alias to /src
import gql from "graphql-tag";
import HistorialSolicitudes from "@/components/intranet/hoteleria/HistorialSolicitudes.vue";
import ModalVerSolicitudHistorial from "@/components/intranet/hoteleria/ModalVerSolicitudHistorial.vue";
import IconHome from "../../../assets/img/intranet/NavVertical/IconHome.vue";

const createSolicitudHoteleria = gql`
  mutation (
    $descripcion_solicitud: String!
    $id_servicio: String!
    $id_team: String!
    $id_habitacion: String!
    $id_cama: String!
    $id_closet: String!
    $detalles: [GuardarDetalleHoteleria]!
    $documentos: [DocumentosSolicitud]!
    $id_turno: String!
  ) {
    createSolicitudHoteleria(
      id_usuario: "1"
      descripcion_solicitud: $descripcion_solicitud
      id_servicio: $id_servicio
      id_team: $id_team
      id_habitacion: $id_habitacion
      id_cama: $id_cama
      id_closet: $id_closet
      id_empresa: "1"
      detalles: $detalles
      documentos: $documentos
      id_turno: $id_turno
    ) {
      id_solicitud
    }
  }
`;

export default {
  name: "HoteleriaSolicitudes",
  data() {
    return {
      butonActive: true,
      formTwoActive: false,
      selected: {
        turno: "Turno",
        team: "Team",
        pabellon: "Seleccionar pabellón",
        habitacion: "Selecionar habitación",
        cama: "Seleccionar cama",
        closet: "Seleccionar clóset",
        servicio: "Seleccionar servicio",
      },
      form: {
        id_turno: "",
        id_team: "",
        id_pabellon: "",
        id_habitacion: "",
        id_cama: "",
        id_closet: "",
        id_servicio: "",
        descripcion_solicitud: "",
        detalles: [],
        documentos: {
          imagen: "",
          formato: "",
        },
      },
      usuario: {
        correo: "",
        telefono_movil: "",
      },
      servicios: [],
      preview_url: "",
      validForm1: true,
      selectedServicio: "",
    };
  },
  components: {
    HistorialSolicitudes,
    ModalVerSolicitudHistorial,
    IconHome,
  },
  computed: {},
  methods: {
    aSolicitar() {
      this.butonActive = true;
      document
        .querySelector(".hoteleria-solicitudes__div-solicitar")
        .classList.remove("d-none");
      document
        .querySelector(".hoteleria-solicitudes__div-historial")
        .classList.add("d-none");
    },
    aHistorial() {
      this.butonActive = false;
      document
        .querySelector(".hoteleria-solicitudes__div-solicitar")
        .classList.add("d-none");
      document
        .querySelector(".hoteleria-solicitudes__div-historial")
        .classList.remove("d-none");
    },
    activateFormTwo() {
      this.formTwoActive = true;

      const el = this.$refs.scrollForm2;

      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 500);
      }
    },
    changeSelected(id, tipo) {
      this.form[tipo] = id;
      if (tipo == "id_servicio") {
        this.form.detalles = [];
      }
      this.$forceUpdate();
    },
    changeSelectedText(nombre, tipo) {
      this.selected[tipo] = nombre;
      if (tipo == "servicio") {
        this.selectedServicio = nombre;
      }
    },
    getDetallesSelectedServicio() {
      this.servicios.find(
        (servicio) => servicio.id_servicio == this.form.id_servicio
      );
    },
    handleFile() {
      const promise = this.getBase64(this.$refs.file.files[0]);
      const x = this;
      promise.then(function (result) {
        x.form.documentos.imagen = result;

        if (x.form.documentos.imagen != "") {
          x.form.documentos.formato = x.$refs.file.files[0]["type"];
        }
      });
    },
    quitarImg() {
      this.form.documentos.imagen = "";
      this.form.documentos.formato = "";
    },
    validateForm1() {
      return (
        this.usuario.telefono_movil == "" ||
        this.usuario.correo == "" ||
        this.form.id_turno == "" ||
        this.form.id_team == "" ||
        this.form.id_pabellon == "" ||
        this.form.id_habitacion == "" ||
        this.form.id_cama == "" ||
        this.form.id_closet == ""
      );
    },
    validateForm2() {
      return (
        this.form.id_servicio == "" ||
        this.form.descripcion_solicitud == "" ||
        this.form.documentos.imagen == "" ||
        this.form.documentos.formato == ""
      );
    },
    onDetalleChecked(event, id, nombre) {
      if (event.target.checked) {
        this.form.detalles.push({
          id_detalle: id,
          descripcion_detalle: nombre,
        });
      } else {
        this.form.detalles = this.form.detalles.filter(
          (detalle) => detalle.id_detalle !== id
        );
      }
      console.log(this.form.detalles);
    },
    handleSubmit() {
      const x = this;

      this.$apollo
        .mutate({
          mutation: createSolicitudHoteleria,
          variables: {
            descripcion_solicitud: this.form.descripcion_solicitud,
            id_servicio: this.form.id_servicio,
            id_team: this.form.id_team,
            id_habitacion: this.form.id_habitacion,
            id_cama: this.form.id_cama,
            id_closet: this.form.id_closet,
            detalles: this.form.detalles,
            documentos: this.form.documentos,
            id_turno: this.form.id_turno,
          },
          errorPolicy: "all",
        })
        .then((data) => {
          if (data.data.createSolicitudHoteleria.id_solicitud) {
            x.showModalExito();
          }
        })
        .catch((e) => {
          if (e.graphQLErrors) {
            e.graphQLErrors.reduce((res, err) => [...res, err.message], []);
          }
        });
    },
    showModalExito() {
      document
        .getElementById("modal-confirmar")
        .querySelector(".btn-close")
        .click();

      document.getElementById("btn-modal-exito").click();
    },
    redirect() {
      location.href = "/hoteleria";
    },
  },
  watch: {
    form: {
      handler() {
        this.$forceUpdate();
      },
      deep: true,
    },
  },
  apollo: {
    usuario: {
      query: gql`
        {
          usuario(id_empresa: "1", id_usuario: "1") {
            id_usuario
            correo
            telefono_movil
          }
        }
      `,
      result(data) {
        this.usuario.correo = data.data.usuario.correo;
        this.usuario.telefono_movil = data.data.usuario.telefono_movil;
      },
    },
    turnos: {
      query: gql`
        {
          turnos(id_empresa: "1") {
            id_turno
            nombre_turno
          }
        }
      `,
    },
    teams: {
      query: gql`
        {
          teams(id_empresa: "1") {
            id_team
            nombre_team
          }
        }
      `,
    },
    getAllPabellones: {
      query: gql`
        {
          getAllPabellones {
            id_pabellon
            nombre_pabellon
          }
        }
      `,
    },
    getAllHabitaciones: {
      query: gql`
        {
          getAllHabitaciones {
            id_habitacion
            nombre_habitacion
          }
        }
      `,
    },
    getAllUbicacionCama: {
      query: gql`
        {
          getAllUbicacionCama {
            id_cama
            nombre_ubicacion
          }
        }
      `,
    },
    getAllUbicacionCloset: {
      query: gql`
        {
          getAllUbicacionCloset {
            id_closet
            nombre_ubicacion
          }
        }
      `,
    },
    getAllServiciosADetalles: {
      query: gql`
        {
          getAllServiciosADetalles(id_empresa: "1") {
            id_servicio
            nombre_servicio
            descripcion_servicio
            detalle {
              id_detalle
              nombre_detalle
            }
          }
        }
      `,
      result(data) {
        this.servicios = data.data.getAllServiciosADetalles;
      },
    },
  },
};
</script>

